let store: Map<string, unknown> = new Map();

export const getGlobalValue = <V>({
  key,
  moduleName,
  createValue,
}: {
  key: string;
  moduleName: string;
  createValue: () => V;
}): V => {
  const storeKey = `${moduleName}_${key}`;
  if (!store.has(storeKey)) {
    store.set(storeKey, createValue());
  }

  return store.get(storeKey) as V;
};

export const resetGlobalStore = () => {
  store = new Map();
};
